export default __webpack_public_path__ + "static/media/wenzilianjie_s.a39bea3f.png";